import { Form, message } from 'antd';
import styles from './searchGroup.less?modules';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import ButtonML from '@/components/button_ml/ButtonML';
import SelectML from '@/components/select_ml/SelectML';
import { toOption } from '@/utils/comUtil.js';
import { fieldPackageStatus, fieldType } from '@/constants.js';
import { useTrigger } from '@/utils/comHook.js';
import EditModal from '@/containers/edit_modal/EditModal';
import ModalML from '@/components/modal_ml/ModalML';
import { history } from 'umi';
import { useDispatch, useSelector } from 'dva';
import { useState, useEffect, useCallback } from 'react';

const SearchGroup = (props) => {
  const [form] = Form.useForm();
  const { fetchData } = props;
  const trigger = useTrigger();
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['cfpmDetail/addField'];
  const [typeObj, setTypeObj] = useState({});
  const [fieldModelOption, setFieldModelOption] = useState([]);
  const [singleListInfo, setSingleListInfo] = useState({});
  const baseInfo = {
    variableType: 'SYSTEM',
    fieldPackageId: history.location.query.id,
  };
  const onFinish = (values) => {
    for (let key in values) {
      if (!values[key]) {
        values[key] = undefined;
      }
    }
    dispatch({
      type: 'cfpmDetail/setSearchValue',
      payload: {
        values,
      },
    });
  };

  const onReset = () => {
    form.resetFields();
  };
  const editSingleField = (value) => {
    let valueUnuse = JSON.parse(JSON.stringify(value));
    if (value.fieldModelId) {
      valueUnuse.fieldModelId = value.fieldModelId[1];
    }
    dispatch({
      type: 'cfpmDetail/addField',
      payload: {
        values: {
          ...valueUnuse,
          ...baseInfo,
        },
      },
      callback: (response) => {
        if (response.code === 0) {
          message.success('新增成功');
          fetchData();
          setSingleListInfo({});
          form.resetFields();
          trigger.close();
        } else {
          message.error(response.message);
        }
      },
    });
  };

  const handleCancel = () => {
    trigger.close();
    setSingleListInfo({});
  };

  // 条件查询列表
  const getFieldModel = useCallback(() => {
    dispatch({
      type: 'cfpmDetail/getFieldModel',
      payload: {},
      callback: (res) => {
        let result = [];
        let obj = {};
        res &&
          res.length > 0 &&
          res.forEach((item) => {
            let child = [];
            item.modelFields.forEach((item2) => {
              child.push({
                value: item2.modelFieldId,
                label: item2.modelFieldName,
              });
              obj[item2.modelFieldId] = item2.modelFieldType;
            });
            result.push({
              value: item.modelGroupName,
              label: item.modelGroupName,
              children: child,
            });
          });
        setTypeObj(obj);
        setFieldModelOption(result);
      },
    });
  }, [dispatch]);

  // 发起请求
  useEffect(() => {
    getFieldModel();
  }, [getFieldModel]);

  const onChange = (e) => {
    // 设置模型选取格式
    let infoUnuse = JSON.parse(JSON.stringify(e));
    infoUnuse.fieldType = typeObj[e.fieldModelId[1]];
    setSingleListInfo(infoUnuse);
  };
  // const displayRender = (label) => {
  //   return label && label[1];
  // };

  let formList = [
    {
      name: 'fieldName',
      type: 'input',
      label: '字段名称',
      required: true,
    },
    {
      name: 'variableName',
      type: 'input',
      label: '变量名',
      required: true,
    },
    {
      name: 'fieldModelId',
      type: 'cascader',
      label: '字段模型',
      required: true,
      allowClear: true,
      onChange: onChange,
      // displayRender: (label)=>{return label && label[1];},
      option: fieldModelOption,
    },
    {
      name: 'fieldType',
      type: 'select',
      label: '字段格式',
      required: true,
      disabled: Boolean(singleListInfo.fieldType),
      option: toOption(fieldType),
    },
    {
      name: 'defaultValue',
      type: 'input',
      label: '默认值',
    },
    {
      name: 'exceptionValue',
      type: 'input',
      label: '异常值',
      required: true,
    },
    {
      name: 'description',
      type: 'input',
      label: '字段描述',
      required: true,
    },
    {
      name: 'fieldPackageStatus',
      type: 'select',
      label: '状态',
      required: true,
      option: toOption(fieldPackageStatus),
    },
  ];
  return (
    <Form
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      <div className={styles.input_contain}>
        {/* 字段名称 */}
        <SingInputML
          height="37px"
          labelwidth="130px"
          inputWidth="200px"
          labelVal="字段名称"
          placeVal="请输入字段名称"
          name="fieldName"
          allowClear={true}
          // icon={}
        />
        {/* 变量名 */}
        <SingInputML
          height="37px"
          labelwidth="130px"
          inputWidth="200px"
          labelVal="变量名"
          placeVal="请输入变量名"
          name="variableName"
          allowClear={true}
          // icon={}
        />

        {/* 状态 */}
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="200px"
          labelVal="状态"
          placeVal="请选择状态"
          name="fieldStatus"
          allowClear={true}
          option={toOption(fieldPackageStatus)}
          // icon={}
        />
      </div>
      <div className={styles.btn_contain}>
        <ButtonML size="large" value="查询" htmlType="submit" fontsize="16px" />
        <ButtonML size="large" value="重置" fontsize="16px" onClick={onReset} />
        <ButtonML
          size="large"
          value="新增"
          fontsize="16px"
          onClick={trigger.open}
        />
        <ButtonML
          size="large"
          value="返回"
          fontsize="16px"
          onClick={() => {
            history.goBack();
          }}
        />
      </div>
      <ModalML
        title="新增"
        handleOk={trigger.open}
        handleCancel={handleCancel}
        visible={trigger.visible}
      >
        <EditModal
          handleCancel={handleCancel}
          formList={formList}
          singleListInfo={singleListInfo}
          loading={loading}
          edit={editSingleField}
        />
      </ModalML>
    </Form>
  );
};

export default SearchGroup;
